import { ReactElement } from 'react';

import {
  Flex,
  IconChevronDown,
  IconHash,
  ListBoxRow,
  SelectMenuValue,
} from '@spotify-internal/encore-web';

import { Account } from '../../hooks';
import { specialFormatSelectedAccount } from '../../utils';

export const accountLabel = (account: Account): string =>
  account.displayName || specialFormatSelectedAccount(account.accountId);

export const WorkspaceSelectTriggerContent = ({
  selectedAccount,
}: {
  selectedAccount?: Account;
}): ReactElement => (
  <>
    <SelectMenuValue>
      {() => (selectedAccount ? accountLabel(selectedAccount) : null)}
    </SelectMenuValue>
    <IconChevronDown aria-hidden="true" />
  </>
);

export const renderWorkspaceOptions = (accounts: Account[]): ReactElement[] =>
  accounts.map(account => (
    <ListBoxRow
      key={account.accountId}
      id={account.accountId}
      textValue={accountLabel(account)}
    >
      {() => (
        <Flex alignItems="center" gap="tighter-2">
          <IconHash size="small" aria-hidden semanticColor="textSubdued" />
          {accountLabel(account)}
        </Flex>
      )}
    </ListBoxRow>
  ));
